import React from "react";
import Announcement from "../E-components/Announcement";
import Categories from "../E-components/Categories";
import Footer from "../E-components/Footer";
import Navbar from "../E-components/Navbar";
import Newsletter from "../E-components/Newsletter";
import Products from "../E-components/Products";
import Slider from "../E-components/Slider";

const EcommerceHome = () => {
    return (
        <div>
            <Announcement />
      <Navbar />
      <Slider />
      <Categories />
      <Products/>
      <Newsletter/>
      <Footer/>
        </div>
    )
}

export default EcommerceHome
